type Props = {
  emoji: string;
};

const EmojiItem = ({ emoji }: Props) => {
  return (
    <div className="flex justify-center items-center w-[2.875rem] h-[2.875rem] text-center rounded-full bg-[#32395E] p-2 text-[1.25rem] z-10">
      {emoji}
    </div>
  );
};

export default EmojiItem;
